import { create } from 'zustand';

type ToastType = 'success' | 'error' | 'info' | 'warning';

interface ToastAction {
  label: string;
  onClick: () => void;
}

interface ToastState {
  open: boolean;
  message: string;
  type: ToastType;
  action?: ToastAction;
  showToast: (options: { message: string; type?: ToastType; action?: ToastAction }) => void;
  hideToast: () => void;
}

export const useToast = create<ToastState>(set => ({
  open: false,
  message: '',
  type: 'info',
  action: undefined,
  showToast: ({ message, type, action }: { message: string; type?: ToastType; action?: ToastAction }) => {
    set({ open: true, message, type, action });
  },
  hideToast: () => set({ open: false, action: undefined }),
}));
